import { ContentService } from 'src/app/services/content/content.service';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LanguagesService } from "src/app/services/languagesService/languages.service";
import { GeolocationService } from "src/app/services/geolocation/geolocation.service";
import { Geolocation } from '@ionic-native/geolocation/ngx';
import { RemoteConfigService } from 'src/app/services/remote-config/remote-config.service';
@Component({
  selector: 'app-geochallenges-list',
  templateUrl: './geochallenges-list.page.html',
  styleUrls: ['./geochallenges-list.page.scss'],
})
export class GeochallengesListPage implements OnInit {
  objUserPosition: any;
  public proximityRadiusInMeters: any;
  constructor(public languageService: LanguagesService,
    public router: Router,
    private geolocationService: GeolocationService,
    private geolocation: Geolocation,
    private contentService: ContentService,
    private remoteConfig: RemoteConfigService) { 
      this.remoteConfig.getSettingsGeochallengesConfig().subscribe((data: any) => {
        this.proximityRadiusInMeters = data['radius-details'];
      });
    }
    

  ngOnInit() {
    // below code to take the updated snapshot of location

    console.log("this.geolocationService.objUser", this.geolocationService.objUserLocation);

    if (this.geolocationService.objUserLocation == undefined) {
      console.log("geolocationService.objUserLocation undefined");
      this.geolocationService.getGeoLocation();

      // below code to subscribe the updated location
      this.geolocationService._Location.subscribe(location => {
        console.log(location);
        this.objUserPosition = location;
      })
    } else {
      console.log("set geolocationService.objUserLocation")
      this.objUserPosition = this.geolocationService.objUserLocation;
    }
    //this.objUserPosition = { lat: 6.2426977, lng: -75.5494904 };
  }



  public viewMore({ detail: { id, type } }) {
    console.log("view more");
    //this.tagsService.setEventTag('challenge_page','challenge_category_clicked');
    this.router.navigate(['app/geochallenges', 'detail',  type, id ]);
  }

  get getTextsIUPageGeochallengesList() {
    //console.log(this.languageService.textsIU.page_home);
    return this.languageService.textsIU.page_kpi_detail;
  }

  getCredentialsChallengesPrefix = async () => {
    return await this.contentService.getSignature();
  };

}
